export default __webpack_public_path__ + "static/image1-7bb166201d91c6a2ddabeca9bb0ca2ff.gif";